// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeAuthenticationApi = class EdgeAuthenticationApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param AuthenticateUserRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationAuthenticateUser(AuthenticateUserRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/AuthenticateUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'AuthenticateUserRequestModel' is not null or undefined
        if (AuthenticateUserRequestModel === null || AuthenticateUserRequestModel === undefined) {
            throw new Error('Required parameter AuthenticateUserRequestModel was null or undefined when calling authenticationAuthenticateUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(AuthenticateUserRequestModel, "AuthenticateUserRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationAuthenticateUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param ChangePasswordRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationChangePassword(ChangePasswordRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/ChangePassword';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ChangePasswordRequestModel' is not null or undefined
        if (ChangePasswordRequestModel === null || ChangePasswordRequestModel === undefined) {
            throw new Error('Required parameter ChangePasswordRequestModel was null or undefined when calling authenticationChangePassword.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ChangePasswordRequestModel, "ChangePasswordRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationChangePasswordDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationGetCurrentUser(body, x_program_id) {
        const _url_ = '/edge/authentication/GetCurrentUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling authenticationGetCurrentUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationGetCurrentUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param IsEmailRegisteredRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationIsEmailRegistered(IsEmailRegisteredRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/IsEmailRegistered';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IsEmailRegisteredRequestModel' is not null or undefined
        if (IsEmailRegisteredRequestModel === null || IsEmailRegisteredRequestModel === undefined) {
            throw new Error('Required parameter IsEmailRegisteredRequestModel was null or undefined when calling authenticationIsEmailRegistered.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IsEmailRegisteredRequestModel, "IsEmailRegisteredRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationIsEmailRegisteredDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param ResetPasswordRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationResetPassword(ResetPasswordRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/ResetPassword';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ResetPasswordRequestModel' is not null or undefined
        if (ResetPasswordRequestModel === null || ResetPasswordRequestModel === undefined) {
            throw new Error('Required parameter ResetPasswordRequestModel was null or undefined when calling authenticationResetPassword.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ResetPasswordRequestModel, "ResetPasswordRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationResetPasswordDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationSaveCurrentUser(ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/SaveCurrentUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel' is not null or undefined
        if (ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel === null || ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel === undefined) {
            throw new Error('Required parameter ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel was null or undefined when calling authenticationSaveCurrentUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel, "ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationSaveCurrentUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientGetAllClients(x_program_id) {
        const _url_ = '/edge/authentication/v2/Client/getAllClients';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2ClientGetAllClientsGetAllClientsResponse");
        }
        return response;
    }
    /**
     *
     * @param userAccountEmail
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userAccountExists(userAccountEmail, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/accountExists/{userAccountEmail}'
            .replace('{' + 'userAccountEmail' + '}', encodeURIComponent(String(userAccountEmail)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'userAccountEmail' is not null or undefined
        if (userAccountEmail === null || userAccountEmail === undefined) {
            throw new Error('Required parameter userAccountEmail was null or undefined when calling userAccountExists.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserAccountExistsUserAccountEmailAccountExistsResponse");
        }
        return response;
    }
    /**
     *
     * @param UsersInternalRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userCreateAnyPortalHubUser(UsersInternalRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/createAnyPortalHubUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UsersInternalRequestModel' is not null or undefined
        if (UsersInternalRequestModel === null || UsersInternalRequestModel === undefined) {
            throw new Error('Required parameter UsersInternalRequestModel was null or undefined when calling userCreateAnyPortalHubUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UsersInternalRequestModel, "UsersInternalRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreateAnyPortalHubUserCreateAnyPortalHubUserResponse");
        }
        return response;
    }
    /**
     *
     * @param UsersInternalRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userCreateAnyPortalStandardUser(UsersInternalRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/createAnyPortalStandardUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UsersInternalRequestModel' is not null or undefined
        if (UsersInternalRequestModel === null || UsersInternalRequestModel === undefined) {
            throw new Error('Required parameter UsersInternalRequestModel was null or undefined when calling userCreateAnyPortalStandardUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UsersInternalRequestModel, "UsersInternalRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreateAnyPortalStandardUserCreateAnyPortalStandardUserResponse");
        }
        return response;
    }
    /**
     *
     * @param UserRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userCreateHubUser(UserRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/createHubUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UserRequestModel' is not null or undefined
        if (UserRequestModel === null || UserRequestModel === undefined) {
            throw new Error('Required parameter UserRequestModel was null or undefined when calling userCreateHubUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UserRequestModel, "UserRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreateHubUserCreateHubUserResponse");
        }
        return response;
    }
    /**
     *
     * @param UserRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userCreatePortalAdmin(UserRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/createPortalAdmin';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UserRequestModel' is not null or undefined
        if (UserRequestModel === null || UserRequestModel === undefined) {
            throw new Error('Required parameter UserRequestModel was null or undefined when calling userCreatePortalAdmin.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UserRequestModel, "UserRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     *
     * @param UsersInternalRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userCreatePortalAdminUser(UsersInternalRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/createPortalAdminUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UsersInternalRequestModel' is not null or undefined
        if (UsersInternalRequestModel === null || UsersInternalRequestModel === undefined) {
            throw new Error('Required parameter UsersInternalRequestModel was null or undefined when calling userCreatePortalAdminUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UsersInternalRequestModel, "UsersInternalRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminUserCreatePortalAdminUserResponse");
        }
        return response;
    }
    /**
     *
     * @param UserRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userCreateStandardUser(UserRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/createStandardUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UserRequestModel' is not null or undefined
        if (UserRequestModel === null || UserRequestModel === undefined) {
            throw new Error('Required parameter UserRequestModel was null or undefined when calling userCreateStandardUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UserRequestModel, "UserRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreateStandardUserCreateStandardUserResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userDeleteUser(id, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/deleteUser/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userDeleteUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'DELETE',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserDeleteUserIdDeleteUserResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userGetUserbyAuth0Id(id, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/getUserbyAuth0Id/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userGetUserbyAuth0Id.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse");
        }
        return response;
    }
    /**
     *
     * @param connectionName
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userGetUsersByConnection(connectionName, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/getUsersByConnection/{connectionName}'
            .replace('{' + 'connectionName' + '}', encodeURIComponent(String(connectionName)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'connectionName' is not null or undefined
        if (connectionName === null || connectionName === undefined) {
            throw new Error('Required parameter connectionName was null or undefined when calling userGetUsersByConnection.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserGetUsersByConnectionConnectionNameGetUsersByConnectionResponse");
        }
        return response;
    }
    /**
     *
     * @param linkedAccountId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userGetUsersByLinkedAccount(linkedAccountId, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/getUsersByLinkedAccount/{linkedAccountId}'
            .replace('{' + 'linkedAccountId' + '}', encodeURIComponent(String(linkedAccountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'linkedAccountId' is not null or undefined
        if (linkedAccountId === null || linkedAccountId === undefined) {
            throw new Error('Required parameter linkedAccountId was null or undefined when calling userGetUsersByLinkedAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserGetUsersByLinkedAccountLinkedAccountIdGetUsersByLinkedAccountResponse");
        }
        return response;
    }
    /**
     *
     * @param UsersWithSiteAccountRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userGetUsersWithSiteAccount(UsersWithSiteAccountRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/getUsersWithSiteAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UsersWithSiteAccountRequestModel' is not null or undefined
        if (UsersWithSiteAccountRequestModel === null || UsersWithSiteAccountRequestModel === undefined) {
            throw new Error('Required parameter UsersWithSiteAccountRequestModel was null or undefined when calling userGetUsersWithSiteAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UsersWithSiteAccountRequestModel, "UsersWithSiteAccountRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserGetUsersWithSiteAccountGetUsersWithSiteAccountResponse");
        }
        return response;
    }
    /**
     *
     * @param ResetPasswordInternalRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userInitiateAnyUserPasswordReset(ResetPasswordInternalRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/initiateAnyUserPasswordReset';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ResetPasswordInternalRequestModel' is not null or undefined
        if (ResetPasswordInternalRequestModel === null || ResetPasswordInternalRequestModel === undefined) {
            throw new Error('Required parameter ResetPasswordInternalRequestModel was null or undefined when calling userInitiateAnyUserPasswordReset.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ResetPasswordInternalRequestModel, "ResetPasswordInternalRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserInitiateAnyUserPasswordResetInitiateAnyUserPasswordResetResponse");
        }
        return response;
    }
    /**
     *
     * @param InitialResetPasswordRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userInitiatePasswordReset(InitialResetPasswordRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/initiatePasswordReset';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'InitialResetPasswordRequestModel' is not null or undefined
        if (InitialResetPasswordRequestModel === null || InitialResetPasswordRequestModel === undefined) {
            throw new Error('Required parameter InitialResetPasswordRequestModel was null or undefined when calling userInitiatePasswordReset.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(InitialResetPasswordRequestModel, "InitialResetPasswordRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserInitiatePasswordResetInitiatePasswordResetResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param UsersInternalRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userUpdateAnyUser(id, UsersInternalRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/updateAnyUser/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userUpdateAnyUser.');
        }
        // verify required parameter 'UsersInternalRequestModel' is not null or undefined
        if (UsersInternalRequestModel === null || UsersInternalRequestModel === undefined) {
            throw new Error('Required parameter UsersInternalRequestModel was null or undefined when calling userUpdateAnyUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UsersInternalRequestModel, "UsersInternalRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserUpdateAnyUserIdUpdateAnyUserResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param UserRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async userUpdateUser(id, UserRequestModel, x_program_id) {
        const _url_ = '/edge/authentication/v2/User/updateUser/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userUpdateUser.');
        }
        // verify required parameter 'UserRequestModel' is not null or undefined
        if (UserRequestModel === null || UserRequestModel === undefined) {
            throw new Error('Required parameter UserRequestModel was null or undefined when calling userUpdateUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UserRequestModel, "UserRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserUpdateUserIdUpdateUserResponse");
        }
        return response;
    }
};
EdgeAuthenticationApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeAuthenticationApi);
export { EdgeAuthenticationApi };
//# sourceMappingURL=edgeAuthenticationApi.js.map